<template>
  <div class="form__field">
    <div class="form__title" v-show="field.title">{{ field.title }}</div>
    <div class="form__spacer" v-show="field.title"></div>
    <label class="form__label" v-show="field.label" :for="identifier">
      {{ field.label }}
    </label>
    <div class="form__field__group">
      <div
        class="form__control"
        v-for="option in field.options"
        :key="field.name + '-' + option.value"
      >
        <input
          type="radio"
          v-model="value"
          :id="identifier + '_' + option.value"
          :name="identifier"
          :value="option.value"
          :disabled="option.disabled"
          @change="validate()"
        />
        <label class="form__box" :for="identifier + '_' + option.value">
          <img class="form__box__img" :src="option.data.img" />
          <div class="form__box__description">
            <span class="mod mod--size--17 mod--weight--700">
              {{ option.label }}
            </span>
            <br />
            <span class="mod mod--size--16 mod--weight--300">
              {{ option.data.description }}
            </span>
          </div>
          <div
            class="form__box__indicator"
            v-show="field.value !== option.value"
          >
            {{ option.data.textInactive }}
            <span class="button__label">{{ option.text }}</span>
            <span class="button__icon icon-right-open-big"></span>
          </div>
          <div
            class="form__box__indicator"
            v-show="field.value === option.value"
          >
            {{ option.data.textActive }}
            <span class="button__label">{{ option.text }}</span>
            <span class="button__icon icon-right-open-big"></span>
          </div>
        </label>
      </div>
    </div>
    <div
      class="form__message form__message--spaced form__message--error"
      v-show="field.error"
    >
      {{ field.error }}
    </div>
    <div class="form__description" v-show="field.description">
      {{ field.description }}
    </div>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-coupon"
};
</script>
